module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "kedvenciam_all_area for_nw_form"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "single_kedvenciam_all mobile-padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('lastname')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2'),
      expression: "'required|min:2'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.lastName),
      expression: "data.lastName"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "data-vv-validate-on": "blur",
      "name": "lastname",
      "type": "name",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('lastname')),
      expression: "errors.has('lastname')"
    }],
    staticClass: "span-err"
  }, [_vm._v("A vezetéknévnek minimum 2 karakter hosszúnak kell lennie")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('firstname')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2'),
      expression: "'required|min:2'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.firstName),
      expression: "data.firstName"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "data-vv-validate-on": "blur",
      "name": "firstname",
      "type": "name",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('firstname')),
      expression: "errors.has('firstname')"
    }],
    staticClass: "span-err"
  }, [_vm._v("A keresztnévnek minimum 2 karakter hosszúnak kell lennie")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('phone')
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^\+?[0-9]{6,12}$/
      }),
      expression: "{ required: true, regex: /^\\+?[0-9]{6,12}$/ }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.phone),
      expression: "data.phone"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "data-vv-validate-on": "blur",
      "name": "phone",
      "type": "name",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone')),
      expression: "errors.has('phone')"
    }],
    staticClass: "span-err"
  }, [_vm._v("A telefonszám csak számokat tartalmazhat szóközök nélkül és egy + jelet az elején (min 6, max 12 karakter)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-2 col-xs-4"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('zipcode')
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Ir. szám*:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|digits:4'),
      expression: "'required|digits:4'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.zipCode),
      expression: "data.zipCode"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "data-vv-validate-on": "blur",
      "name": "zipcode",
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.zipCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "zipCode", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('zipcode')),
      expression: "errors.has('zipcode')"
    }],
    staticClass: "span-err"
  }, [_vm._v("Az irányítószámnak egy 4 jegyű számnak kell lennie")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 col-xs-8"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('city')
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Település*:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:2'),
      expression: "'required|min:2'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.city),
      expression: "data.city"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "data-vv-validate-on": "blur",
      "name": "city",
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "city", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('city')),
      expression: "errors.has('city')"
    }],
    staticClass: "span-err"
  }, [_vm._v("A város neve nem megfelelő")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('address')
    }
  }, [_c('label', {
    staticStyle: {
      "font-weight": "normal",
      "font-size": "12px"
    },
    attrs: {
      "for": ""
    }
  }, [_vm._v("Utca, házszám*:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:4'),
      expression: "'required|min:4'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.data.address),
      expression: "data.address"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "data-vv-validate-on": "blur",
      "name": "address",
      "type": "text",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.data.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "address", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('address')),
      expression: "errors.has('address')"
    }],
    staticClass: "span-err"
  }, [_vm._v("A utca, házszám nem megfelelő")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-9"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('company')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.companyName),
      expression: "data.companyName"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "data-vv-validate-on": "blur",
      "name": "company",
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.data.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('company')),
      expression: "errors.has('company')"
    }],
    staticClass: "span-err"
  }, [_vm._v("A cégnévnek minimum 2 karakter hosszúnak kell lennie")])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "vezteknev_title"
  }, [_c('h6', [_vm._v("Vezetéknév*:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "vezteknev_title"
  }, [_c('h6', [_vm._v("Keresztnév*:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "vezteknev_title"
  }, [_c('h6', [_vm._v("Telefonszám*:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "vezteknev_title"
  }, [_c('h6', [_vm._v("Cím*:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    staticClass: "vezteknev_title"
  }, [_c('h6', [_vm._v("Cég név:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b39dcc5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/dashboard/profile/Data.vue
// module id = 119
// module chunks = 0 1 2